<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="h1" data-automation-id="dialog-title">{{ lookupTitleType }} Lookup</h2>
  <button
    data-automation-id="dialog-close-button"
    mat-icon-button
    mat-dialog-close
    aria-label="Close {{ lookupTitleType }} Lookup dialog"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div [ngSwitch]="this.lookupData.lookupType" class="mb-3">
    <app-healthcare-provider-lookup-form
      *ngSwitchCase="LookupType.HealthcareProvider"
      (enterKey)="search()"
      #childForm
    ></app-healthcare-provider-lookup-form>
    <app-healthcare-provider-lookup-supervisory-relationship-form
      *ngSwitchCase="LookupType.HealthcareProviderSupervisory"
      (enterKey)="search()"
      #childForm
      [queryObject]="initialQueryObject"
    ></app-healthcare-provider-lookup-supervisory-relationship-form>
    <app-medical-supplier-lookup-form
      *ngSwitchCase="LookupType.MedicalSupplier"
      (enterKey)="search()"
      #childForm
    ></app-medical-supplier-lookup-form>
    <app-claimant-lookup-form
      *ngSwitchCase="LookupType.Claimant"
      (enterKey)="search()"
      #childForm
    ></app-claimant-lookup-form>
    <app-employer-lookup-form
      class="mb-3"
      *ngSwitchCase="LookupType.Employer"
      (enterKey)="search()"
      #childForm
    ></app-employer-lookup-form>
    <app-insurer-lookup-form
      *ngSwitchCase="LookupType.Insurer"
      (enterKey)="search()"
      #childForm
    ></app-insurer-lookup-form>
    <app-insurer-external-lookup-form
      *ngSwitchCase="LookupType.InsurerExternal"
      (enterKey)="search()"
      #childForm
    ></app-insurer-external-lookup-form>
    <app-third-party-administrator-lookup-form
      *ngSwitchCase="LookupType.ThirdPartyAdministrator"
      (enterKey)="search()"
      #childForm
    ></app-third-party-administrator-lookup-form>
    <app-third-party-administrator-external-lookup-form
      *ngSwitchCase="LookupType.ThirdPartyAdministratorExternal"
      (enterKey)="search()"
      #childForm
    ></app-third-party-administrator-external-lookup-form>
    <app-system-user-lookup-form
      *ngSwitchCase="LookupType.SystemUser"
      (enterKey)="search()"
      #childForm
    ></app-system-user-lookup-form>
    <lib-external-user-lookup-form
      *ngSwitchCase="LookupType.ExternalSystemUser"
      [queryObject]="initialQueryObject"
      (enterKey)="search()"
      #childForm
    ></lib-external-user-lookup-form>
  </div>
  <app-datatable
    *ngIf="hasSearched"
    [columns]="columns"
    [dataUrl]="dataUrl"
    [queryObject]="query"
    [defaultSort]="defaultSort"
    (rowSelected)="selectRow($event)"
    [enableRowTabSelect]="this.lookupData.lookupType === LookupType.ExternalSystemUser"
    [scrollV]="false"
    [scrollH]="false"
    [disableFiltering]="true"
    [rowHeight]="'auto'"
    #datatable
    data-automation-id="generic-lookup_202130142834"
  ></app-datatable>
  <div class="row">
    <div class="col-12 mt-2">
      <button
        class="mb-3"
        type="button"
        color="primary"
        data-automation-id="generic-lookup_202130142845"
        mat-flat-button
        (click)="search()"
        [disabled]="!(this.childForm && this.childForm.isValid())"
        aria-label="Lookup"
      >
        <mat-icon>search</mat-icon>
        <span>Lookup</span>
      </button>
      <button
        class="mb-3 ms-3"
        type="button"
        color="primary"
        data-automation-id="generic-lookup_202130142850"
        mat-stroked-button
        (click)="clear()"
        aria-label="Clear"
      >
        <span>Clear</span>
      </button>
      <button
        *ngIf="createPermission"
        type="button"
        class="mb-3 ms-3 mat-simple-button"
        color="primary"
        data-automation-id="generic-lookup_202130142853"
        mat-button
        (click)="openLinkInNewTab(createLink)"
        mat-dialog-close
        aria-label="Create New"
      >
        <span>Create New {{ lookupData.lookupType }}</span>
      </button>
      <button
        type="button"
        class="mb-3 ms-3 mat-simple-button"
        color="primary"
        data-automation-id="generic-lookup_202130142857"
        mat-button
        (click)="goToFullSearchLink(searchLink, lookupData.lookupType)"
        mat-dialog-close
        aria-label="Open Full Search"
        *ngIf="!isExternal"
      >
        <span>Full Search</span>
      </button>
    </div>
  </div>
  <div class="dialog-footer">
    <button
      type="button"
      color="primary"
      data-automation-id="modal-save-button"
      mat-flat-button
      [mat-dialog-close]="selectedRow"
      [disabled]="!hasSelected"
      aria-label="Submit {{ lookupTitleType }} Lookup form"
    >
      <span>Confirm</span>
    </button>
    <button
      type="button"
      class="ms-3"
      color="primary"
      data-automation-id="modal-cancel-button"
      aria-label="Close {{ lookupTitleType }} Lookup dialog"
      mat-dialog-close
      mat-stroked-button
    >
      <span>Cancel</span>
    </button>
  </div>
</mat-dialog-content>

<!-- #region Healthcare Provider Templates -->
<ng-template #healthcareIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.healthcareProviderId"
    data-automation-id="generic-lookup_202130142908"
    [routerLink]="AppUrls.entities.healthcareProvider.details(row.healthcareProviderId)"
    target="_blank"
    class="link--open-new"
  >
    {{ row.healthcareProviderId | entityFormatter: EntityType.HealthcareProvider }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<!-- #endregion -->

<!-- #region Medical Supplier Templates -->
<ng-template #medicalSupplierIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.medicalSupplierId"
    data-automation-id="generic-lookup_202130142920"
    [routerLink]="AppUrls.entities.medicalSupplier.details(row.medicalSupplierId)"
    target="_blank"
    class="link--open-new"
  >
    {{ row.medicalSupplierId | entityFormatter: EntityType.MedicalSupplier }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<!-- #endregion -->

<!-- #region Internal Insurer-->
<ng-template #insurerIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.insurerId"
    data-automation-id="generic-lookup_202130142923"
    [routerLink]="AppUrls.entities.insurer.details(row.insurerId)"
    target="_blank"
    class="link--open-new"
  >
    {{ row.insurerId | entityFormatter: EntityType.Insurer }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<ng-template #insuranceNumberTemplate let-row="row">
  <div ng-show="!!row.wNumber" data-automation-id="generic-lookup_202130142930">
    {{ row.wNumber | prefix: 'W' }}
  </div>
  <div ng-show="!!row.bNumber" data-automation-id="generic-lookup_202130142930">
    {{ row.bNumber | prefix: 'B' }}
  </div>
</ng-template>
<!-- #endregion -->

<!-- #region External Insurer-->
<ng-template #insurerWNumberIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="value"
    data-automation-id="generic-lookup_202130143005"
    [routerLink]="AppUrls.entities.insurer.details(row.insurerId)"
    target="_blank"
    class="link--open-new"
  >
    {{ value | prefix: 'W' }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<ng-template #insurerBNumberIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="value"
    data-automation-id="generic-lookup_202130143008"
    [routerLink]="AppUrls.entities.insurer.details(row.insurerId)"
    target="_blank"
    class="link--open-new"
  >
    {{ value | prefix: 'B' }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<ng-template #feinDisplayMaskTemplate let-row="row" let-value="value">
  **-***{{ value }}
</ng-template>
<!-- #endregion -->

<!-- #region Claimant Templates -->
<ng-template #claimantIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.claimantId"
    data-automation-id="generic-lookup_202130143014"
    [routerLink]="AppUrls.entities.claimant.details(row.claimantId)"
    target="_blank"
    class="link--open-new"
  >
    {{ row.claimantId | entityFormatter: EntityType.Claimant }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<!-- #endregion -->

<!-- #region Employer Templates -->
<ng-template #employerIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.employerId"
    data-automation-id="generic-lookup_202130143018"
    [routerLink]="AppUrls.entities.employer.details(row.employerId)"
    target="_blank"
    class="link--open-new"
  >
    {{ row.employerId | entityFormatter: EntityType.Employer }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<!-- #endregion -->

<!-- #region Third Party Administrator Templates -->
<ng-template #thirdPartyAdministratorIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.thirdPartyAdministratorId"
    data-automation-id="generic-lookup_202130143021"
    [routerLink]="AppUrls.entities.thirdPartyAdministrator.details(row.thirdPartyAdministratorId)"
    target="_blank"
    class="link--open-new"
  >
    {{ row.thirdPartyAdministratorId | entityFormatter: EntityType.ThirdPartyAdministrator }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<!-- #endregion -->

<!-- #region External Third Party Administrator Templates -->
<ng-template #thirdPartyAdministratorExternalIdTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.tpaNumber"
    data-automation-id="generic-lookup_202130143026"
    [routerLink]="AppUrls.entities.thirdPartyAdministrator.details(row.thirdPartyAdministratorId)"
    target="_blank"
    class="link--open-new"
  >
    {{ row.tpaNumber }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
</ng-template>
<ng-template #feinDisplayMaskTemplateTPA let-row="row" let-value="value">
  **-***{{ value }}
</ng-template>
<!-- #endregion -->

<!-- #region SSN Template -->
<ng-template #ssnTemplate let-row="row" let-value="value">
  ***-**-{{ value.substr(value.length - 4, value.length) }}
</ng-template>
<!-- #endregion -->

<ng-template #addressTemplate let-row="row" let-value="value">
  <span>{{ value }}</span>
  <br />
  <span *ngIf="row.addressLine2">
    {{ row.addressLine2 }}
    <br />
  </span>
  <!-- prettier-ignore -->
  <span *ngIf="row.city">{{ row.city }}, </span>
  <!-- prettier-ignore -->
  <span *ngIf="row.stateProvinceCode">{{ row.stateProvinceCode }} </span>
  <span>{{ row.postalCode }}</span>
</ng-template>

<!-- #region Full Name Template -->
<ng-template #nameTemplate let-row="row" let-value="value">
  <div data-automation-id="generic-lookup_202130143040">
    <span *ngIf="row.lastName">
      {{
        row.lastName.trim() +
          ((row.lastName && row.firstName) ||
          (row.lastName && row.middleName) ||
          (row.lastName && row.firstName && row.middleName)
            ? ','
            : '')
      }}
    </span>
    <span *ngIf="row.firstName">{{ ' ' + row.firstName.trim() }}</span>
    <span *ngIf="row.middleName">{{ ' ' + row.middleName.trim() }}</span>
  </div>
</ng-template>
<!-- #endregion -->
